import type { StorySolutionData } from "types/ContentHub/Stories";

import Button from "../../../atoms/Button";
import VideoIframe from "../../../atoms/VideoIframe";
import { getLinkTargetValue } from "../../../utils/contentHubComponentsUtils";

import { getStoryImage } from "./StoryResult";

interface StorySolutionComponentProps {
  storySolution: StorySolutionData;
}

export default function StorySolution({
  storySolution,
}: Readonly<StorySolutionComponentProps>) {
  return (
    <div>
      <div className="mx-auto bg-white w-full lg:w-(--article-container-width) max-lg:px-4">
        {storySolution?.SolutionHeading && (
          <h2 className="text-ecolab-blue text-[26px] font-normal leading-[28px] mb-4 align-middle">
            {storySolution?.SolutionHeading}
          </h2>
        )}
        {storySolution?.SolutionBodyContent && (
          <div className="text-base font-normal text-charcoal-black space-y-1 wrap-anywhere richtext-content mb-5">
            <div
              dangerouslySetInnerHTML={{
                __html: storySolution?.SolutionBodyContent,
              }}
            ></div>
          </div>
        )}
        {storySolution?.StorySolution1VideoURL ? (
          <div className="w-full mb-5">
            <VideoIframe src={storySolution?.StorySolution1VideoURL} />
          </div>
        ) : (
          getStoryImage(
            storySolution?.StorySolution1ToAsset?.results?.[0]
              ?.assetToPublicLink?.results,
          )
        )}
        {(storySolution?.SolutionPrimaryLink ||
          storySolution?.SolutionSecondaryLink) && (
          <div className="md:flex gap-x-2.5">
            {storySolution?.SolutionPrimaryLink && (
              <div className="mb-4 gap-x-2.5">
                <Button
                  buttonType={"primary"}
                  className="inline-flex justify-center items-center m-0! max-sm:w-full"
                  field={{
                    value: {
                      href: storySolution?.SolutionPrimaryLink,
                      text:
                        storySolution?.SolutionPrimaryLinkText ||
                        storySolution?.SolutionPrimaryLink,
                      target: getLinkTargetValue(
                        storySolution?.SolutionPrimaryLink,
                      ),
                      linktype: "",
                    },
                  }}
                  tabIndex={0}
                  iconName=""
                  aria-label={
                    storySolution?.SolutionPrimaryLinkText ||
                    storySolution?.SolutionPrimaryLink
                  }
                />
              </div>
            )}
            {storySolution?.SolutionSecondaryLink && (
              <div className="mb-4">
                <Button
                  buttonType={"secondary"}
                  className="inline-flex justify-center items-center m-0! max-sm:w-full"
                  field={{
                    value: {
                      href: storySolution?.SolutionSecondaryLink,
                      text:
                        storySolution?.SolutionSecondaryLinkText ||
                        storySolution?.SolutionSecondaryLink,
                      target: getLinkTargetValue(
                        storySolution?.SolutionSecondaryLink,
                      ),
                      linktype: "",
                    },
                  }}
                  tabIndex={0}
                  iconName=""
                  aria-label={
                    storySolution?.SolutionSecondaryLinkText ||
                    storySolution?.SolutionSecondaryLink
                  }
                />
              </div>
            )}
          </div>
        )}
      </div>
      {(storySolution?.StoryPullQuoteContent ||
        storySolution?.StoryPullQuoteSourceTitleRole ||
        storySolution?.StoryPullQuoteSource) && (
        <div className="bg-light-blue py-(--global-component-spacing) my-8 empty:hidden">
          <div className="mx-auto w-full lg:w-(--article-container-width) px-(--spacing-thirtytwo)">
            {storySolution?.StoryPullQuoteContent && (
              <h2 className="wrap-anywhere text-[22px] leading-[24px] antialiased text-ecolab-blue mt-0 lg:text-[36px] lg:leading-[44px] tracking-normal font-normal mb-6 px-0.5 lg:px-2.5">
                &quot;{storySolution?.StoryPullQuoteContent}&quot;
              </h2>
            )}
            {(storySolution?.StoryPullQuoteSourceTitleRole ||
              storySolution?.StoryPullQuoteSource) && (
              <h3 className="wrap-anywhere text-charcoal-black text-[14px] leading-[20px] antialiased mt-0 tracking-normal font-normal mb-1 px-0.5 lg:px-2.5">
                &#8212;{" "}
                <span className="text-[22px] font-medium leading-[24px]">
                  {storySolution?.StoryPullQuoteSource}
                </span>
                ,{" "}
                <span className="text-[22px] leading-[24px]">
                  {storySolution?.StoryPullQuoteSourceTitleRole}
                </span>
              </h3>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
